module.exports = __webpack_public_path__ + "static/media/solar-inverter.0701f14c.jpg";